import {
  Avatar,
  Button,
  Card,
  Col,
  DatePicker,
  Divider,
  message,
  Form,
  Input,
  Row,
  // Select,
  Typography,
  Upload,
  Spin,
} from "antd";
import CaSideNav from "../../../components/AdminComponents/CaSideNav";
import { CaAdminLearningMenu } from "../../../components/AdminComponents/MenuItems";
import SecondaryNav from "../../../components/AdminComponents/SecondaryNav2";
import { remainingViewportHeight } from "../../../components/icons/ApplicationColor";
import {
  BookOutlined,
  InfoCircleTwoTone,
  UserOutlined,
  ContainerOutlined,
  InboxOutlined,
  RetweetOutlined,
  SaveOutlined,
  BackwardOutlined,
  UpOutlined,
  DownOutlined,
  EditTwoTone,
} from "@ant-design/icons";
import "./RecordAddStyles.css";
import axiosInstance from "../../../api/Axios";
import { useCallback, useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import dayjs from "dayjs"; // optional, for formatting
import { uploadFileCourse } from "./courseUtils";
import { useNavigate, useParams } from "react-router-dom";
import FilePreviewModal from "../../../components/FilePreviewModal";
import { accessImpersontate } from "../../../config";
const { Title, Paragraph, Text } = Typography;
const { Dragger } = Upload;

const LearningRecordsEdit = () => {
  const { id } = useParams();
  const [form] = Form.useForm();
  const [messageApi, contextHolder] = message.useMessage();
  const userInfo = useSelector((state) => state.user);
  const history = useNavigate();
  function getCookie(name) {
    const cookies = document.cookie.split("; ");
    for (let i = 0; i < cookies.length; i++) {
      const [cookieName, cookieValue] = cookies[i].split("=");
      if (cookieName === name) {
        return cookieValue;
      }
    }
    return null;
  }
  const [data1, setData1] = useState([]);
  const [loading, setLoading] = useState(true);
  const LoadUserData = useCallback(async () => {
    try {
      const res = await axiosInstance.get(`/learningrecordlist/?id=${id}`);
      setData1(res?.data?.[0]);
    } catch (err) {
      console.log(err);
    } finally {
      setLoading(false);
    }
  }, [id]);

  useEffect(() => {
    LoadUserData();
  }, [LoadUserData]);
  console.log(data1, loading);

  const ImpersonateAccess = !accessImpersontate(
    userInfo?.data?.impersonate_acc
  );
  const csrfToken = getCookie("csrftoken");
  const [certifcate, setCertificate] = useState("");
  const [certificateFileList, setCertificateFileList] = useState([]);
  const [proofFleList, setProofFileList] = useState([]);
  const [proof, setProof] = useState("");
  const [attachments, setAttachments] = useState([]);
  const [attachmentsFileList, setAttachmentsFileList] = useState([]);
  const handleUpload = async (file, type) => {
    const file_name = await uploadFileCourse(file, "learning", csrfToken);
    if (type === "certificate") {
      setCertificate(file_name);
    } else if (type === "proof") {
      setProof(file_name);
    } else if (type === "attachment") {
      setAttachments((prev) => [...prev, { file_name }]);
    }
  };

  const handleSubmit = async (values) => {
    const normalizedValues = Object.fromEntries(
      Object.entries(values).filter(
        ([key, value]) => value !== null && value !== undefined
      )
    );
    const payload = {
      training_record: {
        user: data1?.user?.id,
        expiry_by: normalizedValues?.expiry_by
          ? dayjs(normalizedValues.expiry_by).format("MMM DD YYYY")
          : "",
        attachment: attachments,
        external_trainer: normalizedValues?.external_trainer,
        external_location: normalizedValues?.external_location,
        source: "E",
        certificate: certifcate,
        attendance_proof: proof,
      },
      // event: {
      //   start_date: normalizedValues?.start_date
      //     ? dayjs(normalizedValues.start_date).format("MMM DD YYYY")
      //     : "",
      //   end_date: normalizedValues?.end_date
      //     ? dayjs(normalizedValues.end_date).format("MMM DD YYYY")
      //     : "",
      // },
    };
    console.log("Form Values:", payload);
    try {
      await axiosInstance.put(`/learningrecordupdate/?id=${id}`, payload, {
        headers: {
          "X-CSRFToken": csrfToken,
        },
      });
      CreateSuccessfull();
    } catch (err) {
      CreateFailed();
    }
  };
  // eslint-disable-next-line no-unused-vars
  const CreateSuccessfull = () => {
    messageApi.open({
      type: "success",
      content: "Learning Record edit success.",
      duration: 5,
    });
    setTimeout(() => {
      history(`/ca-admin/trainery-learn/records/listing`);
    }, 2000);
  };

  // eslint-disable-next-line no-unused-vars
  const CreateFailed = () => {
    messageApi.open({
      type: "error",
      content: "Record Edit failed",
      duration: 5,
    });
  };
  const [showMore, setShowMore] = useState(false);
  const [previewVisible, setPreviewVisible] = useState(false);
  const [selectedFile, setSelectedFile] = useState("");
  const [selectedRecord, setSelectedRecord] = useState();
  const handlePreview = (fileUrl, record) => {
    setSelectedFile(fileUrl);
    setPreviewVisible(true);
    setSelectedRecord(record);
  };
  const formRef = useRef();

  const loadForm = useCallback(() => {
    if (!loading && formRef.current) {
      const formValues = {
        created_at: data1?.created_at ? dayjs(data1?.created_at) : null,
        expiry_by: data1?.expiry_by ? dayjs(data1.expiry_by) : null,

        first_name: data1?.user?.first_name,
        last_name: data1?.user?.last_name,
        email: data1?.user?.email,
        location: data1?.user?.location,
        job_title: data1?.user?.job_title,
        entity: data1?.user?.entity_name,
        division: data1?.user?.division_name,
        department: data1?.user?.department_name,

        source: data1?.event?.source,
        start_date: data1?.event?.start_date
          ? dayjs(data1.event.start_date, "MMM DD YYYY")
          : null,
        end_date: data1?.event?.end_date
          ? dayjs(data1.event.end_date, "MMM DD YYYY")
          : null,

        name: data1?.event?.course?.name,
        course_id: data1?.event?.course?.course_id,
        mode: data1?.event?.course?.mode,
        language: data1?.event?.course?.language,
        external_trainer: data1?.event?.external_trainer,
        external_location: data1?.event?.external_location,
      };
      formRef.current.setFieldsValue(formValues);
      if (data1?.certificate) {
        setCertificate(data1.certificate);
        setCertificateFileList([
          {
            uid: "-1", // AntD needs a unique id
            name: data1.certificate.split("/").pop(), // file name from URL
            status: "done",
            url: data1.certificate, // the actual URL for preview/download
          },
        ]);
      }
      if (data1?.attendance_proof) {
        setProof(data1?.attendance_proof);
        setProofFileList([
          {
            uid: "-1", // AntD needs a unique id
            name: data1.attendance_proof.split("/").pop(), // file name from URL
            status: "done",
            url: data1.attendance_proof, // the actual URL for preview/download
          },
        ]);
      }

      // Prefill from API data
      if (data1?.attachment_url?.length) {
        const prefilledFiles = data1?.attachment_url?.map((file, index) => ({
          uid: `-${index + 1}`, // AntD unique id
          name: file.file_name.split("/").pop(), // extract filename
          status: "done",
          url: file.url,
        }));
        const attachmentsArray = data1?.attachment_url?.map((file) => ({
          file_name: file.file_name,
        }));

        setAttachments(attachmentsArray);

        setAttachmentsFileList(prefilledFiles);
        formRef.current.setFieldsValue({ attachments: prefilledFiles });
        console.log(prefilledFiles);
      }
    }
  }, [loading, data1]);

  // const handleReset = () => {
  //   loadForm();
  // };
  useEffect(() => {
    if (!loading && formRef.current) {
      loadForm();
    }
  }, [loading, data1, loadForm]);
  console.log(attachments);
  const LearningRecordsEditNav = () => {
    const datasend = [
      {
        path: `/ca-admin/trainery-learn/records/edit/${id}`,
        name: data1?.is_editable ? "Edit Record" : "View Record",
        icon: <EditTwoTone />,
      },
    ];
    const filteredDatasend = datasend.filter((item) => item !== false);
    return filteredDatasend;
  };
  return (
    <CaSideNav props={CaAdminLearningMenu}>
      {contextHolder}
      <SecondaryNav menuItems={LearningRecordsEditNav} />
      <Spin spinning={loading}>
        <div
          style={{
            background: "#f4f4f4",
            width: "100%",
            height: remainingViewportHeight(14),
            display: "flex",
            justifyContent: "center",
            alignItems: "flex-start",
            padding: "24px",
            overflowY: "auto",
          }}
        >
          <Card
            style={{
              width: "70%",
              boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
              borderRadius: "10px",
            }}
            hoverable
          >
            <Title level={4}>
              Learning Record {data1?.is_editable ? "Edit" : "View"}
            </Title>
            <Paragraph type="secondary">
              {data1?.is_editable
                ? " Modify learning records with the available data."
                : " View learning records with the available data."}
            </Paragraph>

            <Form
              layout="vertical"
              onFinish={handleSubmit}
              form={form}
              ref={formRef}
              disabled={!data1?.is_editable || !ImpersonateAccess}
            >
              {/* ✅ Box: Basic Details */}

              <Card
                size="small"
                style={{
                  marginBottom: 24,
                  border: "1px solid #e0e0e0",
                  borderRadius: "12px",
                  background: "#fafafa",
                  boxShadow: "0 1px 4px rgba(0,0,0,0.08)",
                }}
                bodyStyle={{ padding: "20px 24px" }}
              >
                <div
                  style={{
                    // marginBottom: 12,
                    display: "flex",
                    alignItems: "center",
                    gap: "10px",
                  }}
                >
                  <InfoCircleTwoTone
                    style={{ fontSize: "18px", color: "#1890ff" }}
                  />
                  <Title level={5} style={{ margin: 0 }}>
                    Basic Details
                  </Title>
                </div>
                <Divider
                  style={{
                    padding: 0,
                    margin: 0,
                    marginTop: 10,
                    marginBottom: 15,
                  }}
                />
                <Row gutter={[16, 16]}>
                  <Col span={8}>
                    <Form.Item
                      className="nospace"
                      label={
                        <Text type="secondary" style={{ padding: "0px" }}>
                          Created At
                        </Text>
                      }
                      name="created_at"
                    >
                      <DatePicker
                        style={{ width: "100%" }}
                        format="MMM DD YYYY"
                        disabled
                      />
                    </Form.Item>
                  </Col>
                  <Col span={8}>
                    <Text type="secondary">Created By</Text>
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        background: "#fff",
                        padding: "3px 12px",
                        borderRadius: "6px",
                        border: "1px solid #d9d9d9",
                      }}
                    >
                      <Avatar
                        size="small"
                        src={userInfo?.data?.profile_pic || undefined}
                        icon={!userInfo?.data?.profile_pic && <UserOutlined />}
                        style={{ marginRight: 10 }}
                      />
                      <Text type="secondary">{userInfo?.data?.full_name}</Text>
                    </div>
                  </Col>
                  <Col span={8}>
                    <Form.Item
                      className="nospace"
                      label={
                        <Text type="secondary" style={{ padding: "0px" }}>
                          Expiry Date
                        </Text>
                      }
                      name="expiry_by"
                    >
                      <DatePicker
                        style={{ width: "100%" }}
                        format="MMM DD YYYY"
                      />
                    </Form.Item>
                  </Col>
                </Row>
              </Card>

              {/* ✅ Box: User Details */}
              <Card
                size="small"
                style={{
                  marginBottom: 24,
                  border: "1px solid #e0e0e0",
                  borderRadius: "12px",
                  background: "#fafafa",
                  boxShadow: "0 1px 4px rgba(0,0,0,0.08)",
                }}
                bodyStyle={{ padding: "20px 24px" }}
              >
                <div
                  style={{
                    // marginBottom: 15,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    gap: "10px",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "10px",
                    }}
                  >
                    <UserOutlined
                      style={{ fontSize: "18px", color: "#722ed1" }}
                    />
                    <Title level={5} style={{ margin: 0 }}>
                      User Details
                    </Title>
                  </div>
                  <div style={{ textAlign: "right", marginTop: 0 }}>
                    <Button
                      type="link"
                      icon={showMore ? <UpOutlined /> : <DownOutlined />}
                      onClick={() => setShowMore((prev) => !prev)}
                      style={{
                        fontWeight: 500,
                        paddingInline: 0,
                        fontSize: 13,
                        color: "#722ed1",
                      }}
                    >
                      {showMore ? "Show Less" : "Show More"}
                    </Button>
                  </div>
                </div>
                <Divider
                  style={{
                    padding: 0,
                    margin: 0,
                    marginTop: 10,
                    marginBottom: 15,
                  }}
                />
                <Row gutter={24}>
                  <Col span={6}>
                    <Form.Item
                      label="First Name"
                      name="first_name"
                      rules={[{ required: true }]}
                    >
                      <Input
                        placeholder="First Name"
                        readOnly
                        style={{ cursor: "not-allowed" }}
                      />
                    </Form.Item>
                  </Col>

                  <Col span={6}>
                    <Form.Item
                      label="Last Name"
                      name="last_name"
                      rules={[{ required: true }]}
                    >
                      <Input
                        placeholder="Last Name"
                        readOnly
                        style={{ cursor: "not-allowed" }}
                      />
                    </Form.Item>
                  </Col>

                  <Col span={7}>
                    <Form.Item label="Email" name="email">
                      <Input
                        placeholder="Email"
                        readOnly
                        style={{ cursor: "not-allowed" }}
                      />
                    </Form.Item>
                  </Col>

                  <Col span={5}>
                    <Form.Item label="Location" name="location">
                      <Input
                        placeholder="Location"
                        readOnly
                        style={{ cursor: "not-allowed" }}
                      />
                    </Form.Item>
                  </Col>
                </Row>

                {showMore && (
                  <Row gutter={24} style={{ transition: "all 0.3s ease" }}>
                    <Col span={6}>
                      <Form.Item label="Work Role" name="job_title">
                        <Input
                          placeholder="Work Role"
                          readOnly
                          style={{ cursor: "not-allowed" }}
                        />
                      </Form.Item>
                    </Col>

                    <Col span={6}>
                      <Form.Item label="Entity" name="entity">
                        <Input
                          placeholder="Entity"
                          readOnly
                          style={{ cursor: "not-allowed" }}
                        />
                      </Form.Item>
                    </Col>

                    <Col span={6}>
                      <Form.Item label="Division" name="division">
                        <Input
                          placeholder="Division"
                          readOnly
                          style={{ cursor: "not-allowed" }}
                        />
                      </Form.Item>
                    </Col>

                    <Col span={6}>
                      <Form.Item label="Department" name="department">
                        <Input
                          placeholder="Department"
                          readOnly
                          style={{ cursor: "not-allowed" }}
                        />
                      </Form.Item>
                    </Col>
                  </Row>
                )}
              </Card>
              <Card
                size="small"
                style={{
                  marginBottom: 24,
                  border: "1px solid #e0e0e0",
                  borderRadius: "12px",
                  background: "#fdfdfd",
                  boxShadow: "0 1px 4px rgba(0,0,0,0.08)",
                }}
                bodyStyle={{ padding: "20px 24px" }}
              >
                <div
                  style={{
                    // marginBottom: 12,
                    display: "flex",
                    alignItems: "center",
                    gap: "10px",
                  }}
                >
                  <BookOutlined
                    style={{ fontSize: "18px", color: "#722ed1" }}
                  />
                  <Title level={5} style={{ margin: 0 }}>
                    Course Details
                  </Title>
                </div>
                <Divider
                  style={{
                    padding: 0,
                    margin: 0,
                    marginTop: 10,
                    marginBottom: 15,
                  }}
                />
                <Row gutter={24}>
                  <Col span={7}>
                    <Form.Item
                      label="Program Name"
                      name="name"
                      rules={[{ required: true }]}
                    >
                      <Input
                        placeholder="program name"
                        readOnly
                        style={{ cursor: "not-allowed" }}
                      />
                    </Form.Item>
                  </Col>

                  <Col span={7}>
                    <Form.Item
                      label="Program ID"
                      name="course_id"
                      rules={[{ required: true }]}
                    >
                      <Input
                        placeholder="Program ID"
                        readOnly
                        style={{ cursor: "not-allowed" }}
                      />
                    </Form.Item>
                  </Col>

                  <Col span={5}>
                    <Form.Item label="Mode" name="mode">
                      <Input
                        placeholder="Course mode"
                        readOnly
                        style={{ cursor: "not-allowed" }}
                      />
                    </Form.Item>
                  </Col>
                  <Col span={5}>
                    <Form.Item label="Language" name="language">
                      <Input
                        placeholder="language"
                        readOnly
                        style={{ cursor: "not-allowed" }}
                      />
                    </Form.Item>
                  </Col>
                </Row>
                <Row gutter={24}>
                  <Col span={7}>
                    <Form.Item label="Trainer Name" name="external_trainer">
                      <Input placeholder="Enter Trainer Name" />
                    </Form.Item>
                  </Col>
                  <Col span={7}>
                    <Form.Item
                      label="Training Location"
                      name="external_location"
                    >
                      <Input placeholder="Enter Training Location" />
                    </Form.Item>
                  </Col>
                </Row>
              </Card>
              {/* ✅ Box: Event Details */}
              <Card
                size="small"
                style={{
                  marginBottom: 24,
                  border: "1px solid #e0e0e0",
                  borderRadius: "12px",
                  background: "#fafafa",
                  boxShadow: "0 1px 4px rgba(0,0,0,0.08)",
                }}
                bodyStyle={{ padding: "20px 24px" }}
              >
                <div
                  style={{
                    // marginBottom: 12,
                    display: "flex",
                    alignItems: "center",
                    gap: "10px",
                  }}
                >
                  <ContainerOutlined
                    style={{ fontSize: "18px", color: "#1890ff" }}
                  />
                  <Title level={5} style={{ margin: 0 }}>
                    Event Details
                  </Title>
                </div>
                <Divider
                  style={{
                    padding: 0,
                    margin: 0,
                    marginTop: 10,
                    marginBottom: 15,
                  }}
                />
                <Row gutter={24}>
                  <Col span={8}>
                    <Form.Item label="Event Name" name="source">
                      <Input
                        placeholder="Enter Event Source"
                        style={{ cursor: "not-allowed" }}
                      />
                    </Form.Item>
                  </Col>
                  <Col span={8}>
                    <Form.Item
                      label="Start Date"
                      name="start_date"
                      rules={[{ required: true }]}
                    >
                      <DatePicker
                        style={{ width: "100%" }}
                        format="MMM DD YYYY"
                        disabled
                      />
                    </Form.Item>
                  </Col>
                  <Col span={8}>
                    <Form.Item label="End Date" name="end_date">
                      <DatePicker
                        style={{ width: "100%" }}
                        format="MMM DD YYYY"
                        disabled
                      />
                    </Form.Item>
                  </Col>
                </Row>

                <Row gutter={24}>
                  <Col span={8}>
                    <Form.Item
                      label="Training Certificate"
                      name="certificate"
                      style={{ width: "100%", marginBottom: 0 }}
                      className="proof-attendance-form-item"
                    >
                      <Upload
                        beforeUpload={() => false}
                        fileList={certificateFileList}
                        showUploadList={true}
                        onChange={(info) => {
                          const latestFileList = info.fileList.slice(-1);
                          setCertificateFileList(latestFileList);

                          const file = info.file.originFileObj || info.file;
                          if (file) {
                            handleUpload(file, "certificate");
                          }
                        }}
                        onPreview={(file) => {
                          const fileUrl =
                            file.url || URL.createObjectURL(file.originFileObj);
                          handlePreview(fileUrl, file);
                        }}
                        className="proof-attendance-upload"
                      >
                        <Button
                          style={{ width: "100%", display: "block" }}
                          type="dashed"
                          className="proof-attendance-btn"
                        >
                          Upload Certificate
                        </Button>
                      </Upload>
                    </Form.Item>
                  </Col>

                  <Col span={8}>
                    <Form.Item
                      label="Proof of Attendance"
                      name="attendanceProof"
                      style={{ width: "100%", marginBottom: 0 }}
                      className="proof-attendance-form-item"
                    >
                      <Upload
                        beforeUpload={() => false}
                        fileList={proofFleList}
                        showUploadList={true}
                        onChange={(info) => {
                          const latestFileList = info.fileList.slice(-1);
                          setProofFileList(latestFileList);
                          const file = info.file.originFileObj || info.file;
                          if (file) {
                            handleUpload(file, "proof");
                          }
                        }}
                        onPreview={(file) => {
                          const fileUrl =
                            file.url || URL.createObjectURL(file.originFileObj);
                          handlePreview(fileUrl, file);
                        }}
                        style={{ width: "100%", display: "block" }}
                        className="proof-attendance-upload"
                      >
                        <Button
                          style={{ width: "100%", display: "block" }}
                          type="dashed"
                          className="proof-attendance-btn"
                        >
                          Upload Proof
                        </Button>
                      </Upload>
                    </Form.Item>
                  </Col>
                </Row>
              </Card>

              <Card
                size="small"
                style={{
                  marginBottom: 24,
                  border: "1px solid #e0e0e0",
                  borderRadius: "12px",
                  background: "#fdfdfd",
                  boxShadow: "0 1px 4px rgba(0,0,0,0.08)",
                  width: "100%",
                }}
                bodyStyle={{ padding: "20px 24px" }}
              >
                <div
                  style={{
                    marginBottom: 12,
                    display: "flex",
                    alignItems: "center",
                    gap: "10px",
                  }}
                >
                  <InboxOutlined
                    style={{ fontSize: "18px", color: "#1890ff" }}
                  />
                  <Title level={5} style={{ margin: 0 }}>
                    Attachments
                  </Title>
                </div>
                <Form.Item
                  name="attachments"
                  valuePropName="fileList"
                  getValueFromEvent={(e) =>
                    Array.isArray(e) ? e : e && e.fileList
                  }
                >
                  <Dragger
                    name="files"
                    multiple
                    style={{ width: "100%" }}
                    beforeUpload={() => false}
                    fileList={attachmentsFileList}
                    accept=".pdf,.doc,.docx,.xls,.xlsx,.csv,.ppt,.pptx,.txt,.jpg,.jpeg,.png,.gif,.bmp,.svg,.zip"
                    onPreview={(file) => {
                      const fileUrl =
                        file.url || URL.createObjectURL(file.originFileObj);
                      handlePreview(fileUrl, file);
                    }}
                    onChange={(info) => {
                      setAttachmentsFileList(info.fileList);

                      // Only handle upload when file is newly added
                      if (info.file.status !== "removed") {
                        const latestFile =
                          info.fileList[info.fileList.length - 1];
                        if (latestFile) {
                          const actualFile =
                            latestFile.originFileObj || latestFile;
                          if (actualFile) {
                            handleUpload(actualFile, "attachment");
                          }
                        }
                      }
                    }}
                    onRemove={(file) => {
                      setAttachmentsFileList((prevList) =>
                        prevList.filter((item) => item.uid !== file.uid)
                      );
                      setAttachments((prev) =>
                        prev.filter(
                          (att) => !att.file_name.includes(file.name) // check by matching filename
                        )
                      );
                    }}
                  >
                    <p className="ant-upload-drag-icon">
                      <InboxOutlined />
                    </p>
                    <p className="ant-upload-text">
                      Click or drag files to this area to upload
                    </p>
                    <p className="ant-upload-hint">
                      Upload any supporting documents, certificates, or other
                      files related to this learning record. You can upload
                      multiple files at once.
                    </p>
                  </Dragger>
                </Form.Item>
              </Card>

              <div
                style={{
                  display: "flex",
                  justifyContent: "flex-end",
                  gap: 16,
                  marginTop: 24,
                }}
              >
                <div>
                  <Form.Item label=" " colon={false}>
                    <Button
                      type="text"
                      htmlType="button"
                      style={{
                        background: "#D3D3D3",
                      }}
                      // onClick={() => {
                      //   history("/ca-admin/trainery-learn/courses/listing");
                      // }}
                    >
                      <BackwardOutlined />
                      Back
                    </Button>
                  </Form.Item>
                </div>
                {data1?.is_editable && ImpersonateAccess && (
                  <>
                    <div>
                      <Form.Item label=" " colon={false}>
                        <Button
                          type="primary"
                          htmlType="submit"
                          className="save-update-btn"
                          // disabled
                        >
                          Update
                          <SaveOutlined />
                        </Button>
                      </Form.Item>
                    </div>
                    <div>
                      <Form.Item label=" " colon={false}>
                        <Button
                          type="text"
                          htmlType="button"
                          // onClick={handleReset}
                          style={{
                            background: "#D3D3D3",
                          }}
                        >
                          Reset
                          <RetweetOutlined />
                        </Button>
                      </Form.Item>
                    </div>
                  </>
                )}
              </div>
            </Form>
          </Card>
        </div>
      </Spin>
      <FilePreviewModal
        open={previewVisible}
        onClose={() => setPreviewVisible(false)}
        fileUrl={selectedFile}
        selectedRecord={selectedRecord}
        showName={false}
      />
    </CaSideNav>
  );
};

export default LearningRecordsEdit;
